import {RootStore} from '../../../stores/RootStore';
import {mapUserInputSelectionMapToChoices} from '../../../mappers/mapUserInputSelectionMapToChoices';
import {SPECS} from '../../../../../specs';

export const setProductPageSlotsProps = (rootStore: RootStore): void => {
  if (!rootStore.$state?.product?.id) {
    return;
  }

  const productPageSlotsElements = [
    rootStore.services.components.productPageDetails1Slot,
    rootStore.services.components.productPageDetails2Slot,
    rootStore.services.components.productPageDetails3Slot,
    rootStore.services.components.productPageDetails4Slot,
    rootStore.services.components.productPageDetails5Slot,
    rootStore.services.components.productPageDetails6Slot,
    rootStore.services.components.productPageDetails7Slot,
    rootStore.services.components.productPageDetails8Slot,
    rootStore.services.components.productPageDetails9Slot,
    rootStore.services.components.productPageTopSlot,
    rootStore.services.components.productPageBottomSlot,
    rootStore.services.components.productPageMedia1Slot,
  ];

  productPageSlotsElements.forEach((slotElement) => {
    if (slotElement?.slot) {
      slotElement.slot.productId = rootStore.$state.product.id;

      if (rootStore.isExperimentEnabled(SPECS.ProductPageSlotsAddMoreProps)) {
        slotElement.slot.selectedVariantId = rootStore.$state.selectedVariant?.id;
        slotElement.slot.selectedChoices = mapUserInputSelectionMapToChoices(rootStore);
        slotElement.slot.quantity = rootStore.$state.quantityInput;
        slotElement.slot.customText = rootStore.$state.userInput.text.map((text) => (text ? text : ''));
      }
    }
  });
};
